import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/interim-report";

export const pagingReport04s = (searchObject) => {
  var url = API_PATH + "/paging-interim-reports";
  return axios.post(url, searchObject);
};

export const getReport04 = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createReport04 = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editReport04 = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteReport04 = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

